export default function DeviceThemeWatcher({ commit }) {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    prefersDark.addEventListener('change', e => commit('deviceTheme/update', e.matches));
}